import React from 'react';
import PropTypes from 'prop-types';

const Line = ({ label, value }) => (
  <p className="text-base leading-6">
    <span className="text-gray-500">{label}: </span>
    <span>{value.toLocaleString()}</span>
  </p>
);

Line.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

export default Line;
